import { useState } from 'react';
import CreateBlog from './Blogcreation';
import BlogList from './BlogList';
import EditBlog from './EditBlog';

export default function BlogManager() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [editingBlog, setEditingBlog] = useState(null);

  const triggerRefresh = () => setRefreshKey(prev => prev + 1);
  const openEditModal = (blog) => setEditingBlog(blog);
  const closeEditModal = () => setEditingBlog(null);

  return (
    <div className="space-y-10 px-4 sm:px-6 lg:px-8 max-w-screen-xl mx-auto">
      <CreateBlog onCreated={triggerRefresh} />
      <BlogList key={refreshKey} openEditModal={openEditModal} onDeleted={triggerRefresh} />
      {editingBlog && (
        <EditBlog blog={editingBlog} onClose={closeEditModal} onUpdated={triggerRefresh} />
      )}
    </div>
  );
}